import PermissionsAddedModal from "./PermissionsAddedModal";

export default PermissionsAddedModal;
